import React, { useEffect, useState } from 'react';
import { DataTable } from '@/components/DataTable';
import { auditLogsService } from '@/services/auditLogs';
import { getApiErrorMessage } from '@/lib/api';
import { toast } from 'sonner';
import { Badge } from '@/components/ui/badge';
import { formatDate } from '@/lib/utils';

export default function AuditPage() {
  const [auditLogs, setAuditLogs] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const r = await auditLogsService.getAll();
        setAuditLogs(r.data);
      } catch (error) {
        toast.error(getApiErrorMessage(error));
      }
    })();
  }, []);

  const columns = [
    {
      key: 'timestamp',
      header: 'Time',
      sortable: true,
      render: (value) => formatDate(value, 'datetime'),
    },
    { key: 'action', header: 'Action', sortable: true },
    { key: 'user', header: 'User', sortable: true },
    { key: 'entity', header: 'Entity', sortable: true },
    {
      key: 'type',
      header: 'Type',
      render: (value) => {
        const variants = {
          Create: 'default',
          Update: 'secondary',
          Delete: 'destructive',
        };
        return <Badge variant={variants[value]}>{value}</Badge>;
      },
    },
  ];

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <h1 className="text-4xl md:text-5xl font-light tracking-tighter mb-2">Audit Log</h1>
        <p className="text-sm md:text-base leading-relaxed text-muted-foreground">
          Track all system activities and changes
        </p>
      </div>

      <DataTable data={auditLogs} columns={columns} searchPlaceholder="Search audit logs..." />
    </div>
  );
}